import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { Department } from '../store/department/department.state'
import { eps } from './url.service'

@Injectable({
  providedIn: 'root'
})
export class DepartmentService {
  private apiUrl = eps.company.departmentApi

  constructor(private http: HttpClient) {}

  getDepartments(params?: string | null, page?: number, limit?: number): Observable<any> {
    const url = params
      ? `${this.apiUrl}?${params}&page=${page}&limit=${limit}`
      : `${this.apiUrl}?page=${page}&limit=${limit}`
    return this.http.get<any>(url)
  }

  blockDepartment(departmentId: string, status: boolean): Observable<any> {
    return this.http.put(`${this.apiUrl}/block/${departmentId}`, { disabled: status })
  }

  deleteDepartment(departmentId: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${departmentId}`, {})
  }

  createDepartment(department: {
    departmentName: string
    businessId: string
  }): Observable<Department> {
    return this.http.post<Department>(`${this.apiUrl}`, department)
  }

  updateDepartment(department: {
    id: string
    departmentName: string
    businessId: string
  }): Observable<Department> {
    return this.http.put<Department>(`${this.apiUrl}/${department.id}`, department)
  }

  unblockDepartment(departmentId: string): Observable<any> {
    return this.http.put(`${this.apiUrl}/unblock/${departmentId}`, {})
  }
}
